module.exports = __webpack_public_path__ + "img/_MG_4974-copped-compressed.5cbb0a60.webp";